import cx from "classnames";
import React from "react";

import { QueryParams as LoginQueryParams } from "@/mk2/apps/users/containers/Login/LoginPage";
import { QueryParams as SignupQueryParams } from "@/mk2/apps/users/containers/Signup/SignupPage";
import { loginUrl, signupUrl } from "@/mk2/apps/users/urls";
import { Link } from "@/mk2/components/Link";
import { GetParams, url } from "@/mk2/helpers/urls";
import { HistoryLocationWithState } from "@/mk2/services/browserHistory";
import { LOGIN_TITLE, SIGNUP_TITLE } from "@/mk/autogenerated/translation";

import styles from "./SignupLoginTabs.mscss";

interface OwnProps {
    location: HistoryLocationWithState;
    query: LoginQueryParams | SignupQueryParams;
}

type Props = OwnProps;

export class SignupLoginTabs extends React.Component<Props> {
    public render() {
        const { query, location } = this.props;

        const isLogin = location.pathname.startsWith(loginUrl);
        const isSignup = location.pathname.startsWith(signupUrl);

        return (
            <ul className={styles.SignupLoginTabs}>
                <li
                    className={cx(
                        styles.SignupLoginTabs__tab,
                        styles["SignupLoginTabs__tab--first"],
                    )}
                >
                    <Link
                        className={cx(
                            styles.SignupLoginTabs__tablink,
                            isSignup && styles["SignupLoginTabs__tablink--active"],
                        )}
                        to={url(signupUrl, {}, query as unknown as GetParams)}
                        data-google-interstitial="false"
                    >
                        {SIGNUP_TITLE}
                    </Link>
                </li>
                <li className={styles.SignupLoginTabs__tab}>
                    <Link
                        className={cx(
                            styles.SignupLoginTabs__tablink,
                            isLogin && styles["SignupLoginTabs__tablink--active"],
                        )}
                        to={url(loginUrl, {}, query as unknown as GetParams)}
                        data-google-interstitial="false"
                    >
                        {LOGIN_TITLE}
                    </Link>
                </li>
            </ul>
        );
    }
}
